import { render, staticRenderFns } from "./visitRecord2.vue?vue&type=template&id=147b279e&scoped=true&"
import script from "./visitRecord2.vue?vue&type=script&lang=js&"
export * from "./visitRecord2.vue?vue&type=script&lang=js&"
import style0 from "./visitRecord2.vue?vue&type=style&index=0&id=147b279e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b279e",
  null
  
)

export default component.exports